"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GridIcon = function GridIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? _constants.colors.darkestGrey : _ref$color;
  return /*#__PURE__*/React.createElement("svg", {
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    version: "1.1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "4.875",
    height: "4.875"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "0",
    y: "0",
    width: "4.875",
    height: "4.875",
    fill: color
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: "8.125",
    y: "0",
    width: "4.875",
    height: "4.875"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "0",
    y: "0",
    width: "4.875",
    height: "4.875",
    fill: color
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: "0",
    y: "8.125",
    width: "4.875",
    height: "4.875"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "0",
    y: "0",
    width: "4.875",
    height: "4.875",
    fill: color
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: "8.125",
    y: "8.125",
    width: "4.875",
    height: "4.875"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: "0",
    y: "0",
    width: "4.875",
    height: "4.875",
    fill: color
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations-Grid",
    transform: "translate(-1260.000000, -112.000000)",
    stroke: color
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1221.000000, 112.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid-Icon",
    transform: "translate(39.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    mask: "url(#mask-2)",
    strokeWidth: "2",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#mask-4)",
    strokeWidth: "2",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#mask-6)",
    strokeWidth: "2",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#mask-8)",
    strokeWidth: "2",
    xlinkHref: "#path-7"
  })))))));
};
var _default = exports["default"] = GridIcon;